module.exports = __webpack_public_path__ + "img/pos2_banner.2eee4016.png";